import { gql } from '@apollo/client';

export const GET_DOCUMENT = gql`
  query GetDocument($docId: ID) {
    documents(docId: $docId) {
      documentId
      vendorOpportunityId
      source
      viewUrl
      docType
      creditSubId
      docDescription
      createdBy
      docName
      documentCreditSubmission {
        creditSubmissionId
        lenderAccess
      }
    }
  }
`;
